import {withTranslation} from '@wix/yoshi-flow-editor'
import {getEventDateInformation} from '../../../../../../../../commons/selectors/event'
import {
  getListImageOpacity,
  getListImagePosition,
  getListLocationAndDateFormat,
} from '../../../../../../../../commons/selectors/settings'
import {
  getDayMonthText,
  getEventsForDay,
  getSelectedDate,
  getSelectedEventId,
} from '../../../../../../selectors/calendar-layout'
import {getEventById} from '../../../../../../selectors/events'
import {
  isDescriptionVisible,
  isFullDateVisible,
  isImageVisible,
  isLocationVisible,
  isMembersVisible,
  isSocialShareVisible,
} from '../../../../../../selectors/list-settings'
import {getComponentConfig, isRibbonVisible} from '../../../../../../selectors/settings'
import {getShareFontSize} from '../../../../../../utils/calendar'
import {AppProps} from '../../../../../app/interfaces'
import {connect} from '../../../../../runtime-context/connect'
import {MonthlyCalendarEventDetailsOwnProps, MonthlyCalendarEventDetailsRuntimeProps} from './interfaces'
import {MonthlyCalendarEventDetails as MonthlyCalendarEventDetailsPresentation} from './monthly-calendar-event-details'

const mapRuntime = (context: AppProps): MonthlyCalendarEventDetailsRuntimeProps => {
  const {state, actions} = context
  const event = getEventById(state, getSelectedEventId(state))

  const componentConfig = getComponentConfig(state)
  const selectedDay = getSelectedDate(state)
  const events = getEventsForDay(context.state, selectedDay)

  return {
    event,
    dayEventCount: events.length,
    dateText: getDayMonthText(state, selectedDay),
    showImage: Boolean(event.mainImage) && isImageVisible(state),
    showLocation: isLocationVisible(state),
    imagePosition: getListImagePosition(componentConfig),
    imageOpacity: getListImageOpacity(componentConfig),
    showFullDate: isFullDateVisible(state),
    showDescription: isDescriptionVisible(state),
    showShare: isSocialShareVisible(state),
    showMembers: isMembersVisible(state, event),
    locationAndDateFormat: getListLocationAndDateFormat(componentConfig),
    fullDate: getEventDateInformation(state, event.id).fullDate,
    shareFontSize: parseInt(getShareFontSize(context), 10),
    showRibbon: isRibbonVisible(state, event),
    closeMonthlyCalendarPopup: () => actions.closeMonthlyCalendarPopup(),
    closeMonthlyCalendarEvent: () => actions.closeMonthlyCalendarEvent(),
  }
}

export const MonthlyCalendarEventDetails = connect<
  MonthlyCalendarEventDetailsOwnProps,
  MonthlyCalendarEventDetailsRuntimeProps
>(mapRuntime)(withTranslation()(MonthlyCalendarEventDetailsPresentation))
export * from './interfaces'
